<template>
  <v-layout row wrap>
    <v-flex xs12 md12>
      <Breadcrumbs 
        :items="$vuetify.breakpoint.smAndDown ? breadcrumbsMobile : category.breadcrumbs"
      />
    </v-flex>

    <v-flex md3>
      <SideMenuMobile v-if="$vuetify.breakpoint.smAndDown"/>
      <SideMenu v-else />
    </v-flex>

    <v-flex xs12 md8 :class="{'ml-4': $vuetify.breakpoint.smAndUp}">
      <SubcategoryList :category="category" />
    </v-flex>
  </v-layout>
</template>
<script>
import { mapActions } from 'vuex';
import SideMenu from '@/components/Helpcenter/SideMenu.vue'
import SubcategoryList from '@/components/Helpcenter/SubcategoryList.vue';
import Breadcrumbs from '@/components/Helpcenter/Breadcrumbs';
import SideMenuMobile from '@/components/Helpcenter/SideMenuMobile.vue';

export default {
  components: {
    Breadcrumbs,
    SideMenu,
    SubcategoryList,
    SideMenuMobile
  },
  data() {
    return {
      category: {},
      breadcrumbsMobile: [
        { to: "/", text: "Inicio", disabled: false, exact: true },
        { to: "/centro-de-ayuda", text: "Centro de ayuda", disabled: false, exact: true }
      ],
    }
  },
  methods: {
    ...mapActions("helpcenter", ["fetchCategory"]),
    async getCategory() {
      const res = await this.fetchCategory(this.$route.params.category)
      this.category = res
    }
  },
  created() {
    this.getCategory()
  },
}
</script>